import { callAct, isOk, statusText, statusOf } from "./apiConfig";

// AUTH / DATA dispatcher — unified onto the PHP backend.
// Components call managedata.sendData({ data:{...}, type:{ act:"loginWithPass" } }, err, ok)
// i.e. already the PHP "act" shape. Previously this routed login to a local Node
// backend (localhost:3001) and dropped everything else. Now it forwards every act
// straight to the real PHP backend via the apiConfig boundary.
//
// success/err routing follows the PHP status code (100–149 = OK). The success
// callback receives the FULL PHP envelope, so App.handleLogin(res) can read
// res.data.token / res.data.business.

// A few screens use client-side field names that differ from the PHP data fields.
const FIELD_ALIASES = {
    firstOrLastName: "privateName",
    firstName: "privateName",
};

function toPhpData(data = {}) {
    const out = {};
    for (const [key, value] of Object.entries(data || {})) {
        out[FIELD_ALIASES[key] || key] = value;
    }
    return out;
}

const sendData = async (payload = {}, errorFunc = () => {}, successFunc = null) => {
    const act = payload?.type?.act;
    if (!act) {
        if (typeof errorFunc === "function") errorFunc("Missing act");
        return;
    }
    try {
        const envelope = await callAct(act, toPhpData(payload.data), payload.authentication || {});
        if (isOk(envelope)) {
            if (typeof successFunc === "function") successFunc(envelope);
        } else if (typeof errorFunc === "function") {
            errorFunc(statusText(envelope) || "Request failed", statusOf(envelope));
        }
        return envelope;
    } catch (error) {
        console.error(`act '${act}' failed`, error);
        const msg = error?.response?.data?.debug?.statusText || "Network error";
        if (typeof errorFunc === "function") errorFunc(msg);
    }
};

export default { sendData };
